export default {
  heading: 'heading',
  paragraph: 'paragraph',
  bubble: 'bubble',
  multipleChoiceReading: 'multiple-choice-reading',
  link: 'link',
};
